import CartCostBlockNew from './CartCostBlockNew'

export default CartCostBlockNew
